<template>
  <div class="ticket">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  methods: {},
};
</script>
<style scoped lang="less">
.ticket {
  background-color: #f8f8f8;
}
</style>
